import React from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import { notificationsQuery } from 'graphql/user/queries/notifications';
import { useNotificationSideDrawerOperations } from 'components/canvas/hooks/use-notification-side-drawer-visibility';
import { useHistory } from 'react-router';
import { useQuery } from '@apollo/client';
import If from 'components/if-statement';
import UserAvatar from 'components/user-avatar';
import EmptyNotificationList from 'components/canvas/components/notification-side-drawer/components/notification-list/components/empty-notification-list';
import BarsLoader from 'components/bars-loader';
import { WithMargin } from 'components/layout';
import { LoaderContainer, Container } from './style';
import {
  NotificationContainer,
  UnreadIndicator,
  Message,
} from 'components/canvas/components/notification-side-drawer/style';
import markNotificationAsSeen from 'graphql/user/mutations/mark-notification-as-seen';
import { global } from 'styles/settings';
import { notEmpty } from 'utils/js';
import { NotificationType } from 'graphql/types';

export interface NotificationListProps {}

const defaultProps = {};

function NotificationList() {
  const history = useHistory();

  const { data, loading, previousData } = useQuery(notificationsQuery, {
    variables: {
      input: { sort: '+createdAt' },
    },
    notifyOnNetworkStatusChange: true,
    pollInterval: 15000,
    fetchPolicy: 'cache-and-network',
  });

  const { hideNotificationSideDrawer } = useNotificationSideDrawerOperations();

  const initialLoad = loading && !previousData;

  function onVisibilityChange(notification) {
    return function (isVisible: boolean) {
      if (isVisible) {
        markNotificationAsSeen({ id: notification.id });
      }
    };
  }

  function renderMessage(notification: any) {
    const surfaceName = notification?.surface?.name;

    const [first, second] = notification?.message?.split('{{surface}}') ?? [];

    const isGrantAccessNotification =
      notification.type === NotificationType.GrantAccess;

    function onClick() {
      if (isGrantAccessNotification) {
        history.push('/surface/' + notification.surface.id);
        hideNotificationSideDrawer();
      }
    }

    return (
      <>
        <Message>{first}</Message>
        <Message
          onClick={onClick}
          bold
          grantAccessNotification={isGrantAccessNotification}>
          &nbsp;{surfaceName}&nbsp;
        </Message>
        <Message>{second}</Message>
      </>
    );
  }

  const hasNotifications = notEmpty(data?.notifications?.edges);

  return (
    <If condition={hasNotifications}>
      <If.Then>
        <Container>
          {data?.notifications?.edges.map(({ node }) => (
            <NotificationContainer key={node.id}>
              <WithMargin left={global.space.rg} right={global.space.rg}>
                <UserAvatar user={node.sender} />
              </WithMargin>

              {node.status !== 'seen' && (
                <VisibilitySensor onChange={onVisibilityChange(node)}>
                  <UnreadIndicator />
                </VisibilitySensor>
              )}
              {renderMessage(node)}
            </NotificationContainer>
          ))}
        </Container>
      </If.Then>
      <If.Else>
        <If condition={initialLoad}>
          <If.Then>
            <LoaderContainer>
              <BarsLoader />
            </LoaderContainer>
          </If.Then>
          <If.Else>
            <EmptyNotificationList />
          </If.Else>
        </If>
      </If.Else>
    </If>
  );
}

NotificationList.defaultProps = defaultProps;

export default NotificationList;
